import { Injectable, inject } from '@angular/core';
import { ToasterService, TranslateService } from '@devinforius/i-essentials';

export type NotificationSeverity = 'success' | 'warn' | 'error' | 'info';

@Injectable({
  providedIn: 'root',
})
export class Notifier {
  private readonly toasterService = inject(ToasterService);
  private readonly translater = inject(TranslateService);

  public show(
    severity: NotificationSeverity,
    title: string,
    message: string,
    life: number = 3000,
  ): void {
    this.toasterService.push(severity, title, message, undefined, life);
  }

  public showSuccess(type: 'creation' | 'update' | 'delete'): void {
    let descriptionKey: string = '';

    switch (type) {
      case 'creation':
        descriptionKey = 'GLOBAL.NOTIFICATION.SUCCESS.DESCRIPTION.CREATE';
        break;
      case 'update':
        descriptionKey = 'GLOBAL.NOTIFICATION.SUCCESS.DESCRIPTION.UPDATE';
        break;
      case 'delete':
        descriptionKey = 'GLOBAL.NOTIFICATION.SUCCESS.DESCRIPTION.DELETE';
        break;
    }

    this.show(
      'success',
      this.translater.instant('GLOBAL.NOTIFICATION.SUCCESS.TITLE'),
      this.translater.instant(descriptionKey),
      5000,
    );
  }

  public showError(
    type: 'server' | 'forbidden' | 'notFound' | 'access' | 'delete' | 'update',
  ): void {
    let descriptionKey: string = '';
    let titleKey: string = '';

    switch (type) {
      case 'server':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.SERVER.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.SERVER.TITLE';
        break;
      case 'forbidden':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.FORBIDDEN.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.FORBIDDEN.TITLE';
        break;
      case 'notFound':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.NOT_FOUND.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.NOT_FOUND.TITLE';
        break;
      case 'access':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.GET.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.GET.TITLE';
        break;
      case 'delete':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.DELETE.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.DELETE.TITLE';
        break;
      case 'update':
        descriptionKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.UPDATE.DESCRIPTION';
        titleKey = 'GLOBAL.NOTIFICATION.ERROR.REQUEST.UPDATE.TITLE';
        break;
    }

    this.show(
      'error',
      this.translater.instant(titleKey),
      this.translater.instant(descriptionKey),
      5000,
    );
  }

  public setKey(key: string): void {
    this.toasterService.setKey(key);
  }

  public clear(): void {
    this.toasterService.clearAll();
  }
}
